import { Box, Grid, Paper, TextField, Typography } from "@mui/material"
import { motion } from "framer-motion"

export const MotionBox = motion(Box)
export const MotionGrid = motion(Grid)
export const MotionPaper = motion(Paper)
export const MotionTypography = motion(Typography)
export const MotionTextField = motion(TextField)
